const e = "AuthService";
export {
  e as AUTH_SERVICE
};
